export let appNameWord = "oCRvwe";
export default {appNameWord};